<template>
    <div class="container">
        <div class="form-top">
            <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                    <div style="display:flex;align-items:center;">
                        <div style="margin-right: 60px;">成员管理</div>
                        <el-input style="width:200px;" placeholder="查找手机号" v-model="searchForm.phone"
                            class="input-with-select" @change="pageChange(1)" clearable>
                            <i class="el-icon-search el-input__icon" slot="suffix"></i>
                        </el-input>
                    </div>
                </el-col>
                <el-col :span="3">
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleEditFormShow('')">新增通知对象
                    </el-button>
                </el-col>
            </el-row>
        </div>
        <div class="form-container">
            <el-table :data="receiverList" style="width: 100%" size="medium" :header-cell-style="{height: '50px'}"
                :row-style="{height: '50px',padding: '5px 0'}">
                <el-table-column label="目标" prop="name" min-width="100"></el-table-column>
                <el-table-column label="邮箱" prop="email" min-width="100"></el-table-column>
                <el-table-column label="手机号" prop="phone" min-width="100"></el-table-column>
                <el-table-column label="创建时间" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.create_time | timeFilter}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="260" fixed='right'>
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button class="operate-btn" icon="el-icon-edit" @click="editStep = 2;handleEditFormShow(scope.row)">编辑</el-button>
                            <el-button :disabled="!!scope.row.wx_open_id" class="operate-btn" icon="el-icon-s-operation"
                                @click="handleBindWx(scope.row)">{{scope.row.wx_open_id ? '已绑定' : '绑定微信'}}</el-button>
                            <el-button class="operate-btn" icon="el-icon-delete" @click="handleDelete(scope.row.id)">删除
                            </el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination background layout="prev, pager, next" :page-size="10" :total="total"
                    @current-change="pageChange" :current-page="currentPage"></el-pagination>
            </div>
        </div>
        <el-dialog title="通知对象" :visible.sync="editFormVisible" width="30%" @closed="handleEditFormClosed">
            <div class="event-dialog-content">
                <kbm-step :config="stepConfig" :current-step-index="editStep"></kbm-step>
                <el-form :model="editForm">
                    <el-form-item label="手机号" label-width="100px" v-show="editStep === 1">
                        <el-input v-model="editForm.phone" placeholder="手机号" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" label-width="100px" v-show="editStep === 2">
                        <el-input v-model="editForm.name" placeholder="姓名" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" label-width="100px" v-show="editStep === 2">
                        <el-input v-model="editForm.email" placeholder="邮箱" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editFormVisible = false">取 消</el-button>
                <el-button style="margin-left: 20px;" type="primary" @click="getPhoneMsg" v-if="editStep === 1"
                    :loading="btnLoading">
                    下一步
                </el-button>
                <el-button style="margin-left: 20px;" type="primary" @click="handleSave" v-if="editStep === 2">
                    确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Core from '../../../core';
import KbmStep from '@/components/kbm-step/KbmStep';

export default {
    components: {
        KbmStep
    },
    props: {
        projectId: {
            default: 0
        }
    },
    data() {
        return {
            searchForm: {
                phone: ''
            },
            receiverList: [],
            total: 0,
            currentPage: 1,
            editFormVisible: false,
            editForm: {
                id: '',
                name: '',
                phone: '',
                email: '',
                wx_open_id: ''
            },
            editStep: 1,
            stepConfig: ['填写手机号', '确认通知对象'],
            btnLoading: false
        };
    },
    watch: {},
    computed: {},
    mounted() {
        this.getReceiverList();
    },
    methods: {
        handleSave() {
            if (this.editForm.id) {
                Core.Api.Receiver.update(
                    this.editForm.id,
                    this.editForm.name,
                    this.editForm.phone,
                    this.editForm.email,
                ).then((res) => {
                    this.pageChange(1);
                    this.handleEditFormClose();
                });
            } else {
                Core.Api.Receiver.save(
                    this.editForm.name,
                    this.editForm.phone,
                    this.editForm.email,
                    this.editForm.wx_open_id
                ).then((res) => {
                    this.pageChange(1);
                    this.handleEditFormClose();
                });
            }
        },
        handleDelete(id) {
            this.$confirm('确定删除该成员？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                Core.Api.Receiver.delete(id).then((res) => {
                    this.pageChange(1);
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
            });
        },
        handleEditFormShow(item) {
            if (item) {
                this.editForm.id = item.id;
                this.editForm.name = item.name;
                this.editForm.phone = item.phone;
                this.editForm.email = item.email;
            }
            this.editFormVisible = true;
        },
        handleEditFormClose() {
            this.editFormVisible = false;
        },
        handleEditFormClosed() {
            Core.Util.emptyObject(this.editForm);
            this.editStep = 1;
        },
        async getPhoneMsg() {
            this.btnLoading = true;
            try {
                const { user } = await Core.Api.User.getUserByPhone(
                    this.editForm.phone
                );
                this.btnLoading = false;
                this.editStep = 2;
                this.editForm.name = user.name;
                this.editForm.email = user.email;
                this.editForm.wx_open_id = user.wx_open_id;
            } catch (error) {
                console.log(error);
            } finally {
                this.btnLoading = false;
            }
        },
        getReceiverList() {
            Core.Api.Receiver.list(
                this.currentPage,
                10,
                this.searchForm.phone
            ).then((res) => {
                this.total = res.count;
                this.receiverList = res.receiver_list;
            });
        },
        pageChange(page) {
            this.currentPage = page;
            this.getReceiverList();
        },
        async handleBindWx({ id }) {
            const res = await this.getWxLoginQrcode(id);
            const wxLoginQrcode = res.url;
            const url = `<iframe src="${wxLoginQrcode}" style="height: 400px;border: none;"></iframe>`;
            this.$alert(url, {
                dangerouslyUseHTMLString: true,
                center: true,
                showConfirmButton: false
            });
        },
        getWxLoginQrcode(id) {
            return Core.Api.User.wxLoginQrcode(2, id);
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    background: #f1f4f9;
    padding: 0 40px;
    @import '@/common/styles/form.scss';
}
</style>